import React from 'react';
import { css } from 'aphrodite';
import './switch-styles.css';
import styles from './switch-styles';

const Switch = (props) => (
  <div className={css(styles.root)}>
    <label className="switch">
      <input type="checkbox" checked={props.checked} onChange={props.onChange} />
        <span className="slider"/>
    </label>
  </div>
);

export default Switch



// WEBPACK FOOTER //
// ./src/components/common/switch/switch.js